import {
  armAcrossChest,
  cuppingEar,
  fingerOnNose,
  flatHandCarryingPlatter,
  flexingArm,
  frownThumbsDown,
  handOnHead,
  handOverHeart,
  handRaisedOath,
  hangLooseGesture,
  kissyFace,
  peaceSignOverEye,
  puffedCheeksWideEyes,
  smileFourFingers,
  smileTongueOut,
  surprisedMouthCover,
  tongueOutSide,
  twoFingerSalute,
  wink,
  zeroOverEye
} from '@/assets/images/verification-examples'
import { type MinimalPhoto } from '@/components'

export const poseOptions: MinimalPhoto[] = [
  {
    description: 'Put your hand over your heart, as if you were giving the Pledge of Allegiance.',
    source: handOverHeart
  },
  { description: 'One horizontal peace signs over your eye.', source: peaceSignOverEye },
  { description: 'Cupping your ear.', source: cuppingEar },
  { description: 'Stick your tongue out on the side of your mouth.', source: tongueOutSide },
  { description: 'Cross your arm over your chest.', source: armAcrossChest },
  { description: 'Give a “hang loose” gesture.', source: hangLooseGesture },
  { description: 'Put your arm up like you are flexing your muscle.', source: flexingArm },
  { description: 'Put your finger on your nose.', source: fingerOnNose },
  { description: 'Smile and stick your tongue out.', source: smileTongueOut },
  { description: 'Puff up your cheeks and make your eyes big.', source: puffedCheeksWideEyes },
  { description: 'Put your flat hand on the top of your head.', source: handOnHead },
  { description: 'Put your hand up as if you are under oath.', source: handRaisedOath },
  { description: 'Frown and give a thumbs down.', source: frownThumbsDown },
  { description: 'Cover your mouth with your fingers like you are surprised.', source: surprisedMouthCover },
  { description: 'Smile and show four fingers.', source: smileFourFingers },
  { description: 'Salute with two fingers on your forehead.', source: twoFingerSalute },
  { description: 'Give a kissy face.', source: kissyFace },
  { description: 'Put one hand in a zero shape over one eye.', source: zeroOverEye },
  { description: 'Give a wink.', source: wink },
  { description: 'Put your hand out flat as if you were carrying a platter.', source: flatHandCarryingPlatter }
]
